module.exports = {
  toggleNavbar() {
    this.getComponent('mobile-menu').toggleNavbar()
  },
}
